import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  summary: string;
  image: string;
  date: string;
  readTime: number;
  tags: string[];
}

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat ? cat.name : slug;
}

export default function ArticleCard({
  slug,
  title,
  category,
  summary,
  image,
  date,
  readTime,
  tags,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group hover:border-primary-200 transition-colors duration-200">
      <Link to={`/article/${slug}`} className="block cursor-pointer">
        <div className="aspect-[16/9] w-full overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="p-4 md:p-5">
          <div className="flex items-center gap-3 mb-3">
            <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
              {getCategoryName(category)}
            </span>
            <span className="text-xs text-foreground-500 whitespace-nowrap">
              <i className="ri-calendar-line mr-1"></i>
              {date}
            </span>
            <span className="text-xs text-foreground-500 whitespace-nowrap">
              <i className="ri-time-line mr-1"></i>
              {readTime} 分钟
            </span>
          </div>
          <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-3">
            {summary}
          </p>
          <div className="flex flex-wrap gap-1.5">
            {tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </Link>
    </article>
  );
}